export default __webpack_public_path__ + "static/media/brew.70726682.png";